import { useRef, useContext, useState, useEffect } from 'react';

import styles from './NotAttachedParticipantsComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { AddConferenceContext } from '../../../contexts/addConferenceContext';
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import InitialsCircleComponent from '../../commons/InitialsCircleComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';
import DeleteNotificationComponent from '../common/DeleteNotificationComponent';
import New_InputTextComponent from '../../../components/keyboard/New_InputTextComponent';
import CustomDropdownComponent from '../../commons/CustomDropdownComponent';

import { getUpcomingConferences } from '../../../utils/UtilitaryFunctions'
import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';


const NotAttachedParticipantsComponent = ({ displayedRoom, isRemote, displayedParticipants, setDisplayedParticipants, participantsFilter, setParticipantsFilter,
    attachedParticipants, setAttachedParticipants, allParticipantsRef, tablePosition, deskHeight, setSelectedInvites, verifyRoomAdmin, setCurrentRoomAdmin, currentRoomAdmin,
    verifyFilters, setVerifyFilters }) => {

    const {
        language, appWidth, socketRef, appHeight, currentUser, setNotificationUpcomingConferences, currentConference, setCurrentConference, deskData, participantsStreams, setAlertMessage,
        setAddGuest, keyboardRef, currentParticipant
    } = useContext(GlobalContext);
    const { conferenceDetailsForParticipants, setAddVisitor, uniqueModerators, setConferenceDetailsForParticipants } = useContext(AddConferenceContext);
    const { editConference, setEditConference } = useContext(ProjectDetailsContext)

    const inputRef = useRef()
    const participantsFilterSearchRef = useRef()
    const currentTargetRef = useRef()
    const activeTouchIdRef = useRef(null);
    const nameRefs = useRef([]);
    const currentConferenceRef = useRef();

    const [isDragging, setIsDragging] = useState(false);
    const [deleteClicked, setDeleteClicked] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState({ value: "all", text: "All" })
    const [selectedParticipant, setSelectedParticipant] = useState()
    const [scrollableStates, setScrollableStates] = useState([]);
    const [verifyShowList, setVerifyShowList] = useState(false);

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const filterOptions = [
        {
            value: "all",
            text: "All"
        },
        {
            value: "Members",
            text: "Members"
        },
        {
            value: "Guests",
            text: "Guests"
        },
        {
            value: "Partners",
            text: "Partners"
        },
        {
            value: "Visitors",
            text: "Visitors"
        }
    ]

    const filteredOptions = filterOptions.filter(option => {
        if (isRemote && option.value === "Visitors") return false;
        if (!isRemote && option.value === "Guests") return false;
        return true;
    });

    useEffect(() => {
        if (conferenceDetailsForParticipants) {
            currentConferenceRef.current = conferenceDetailsForParticipants;
        } else {
            currentConferenceRef.current = currentConference;
        }
    }, [])

    useEffect(() => {
        if (allParticipantsRef.current) {
            let result = []
            if (inputRef.current.value) {
                result = allParticipantsRef.current.filter(participant => participant.name?.toLowerCase().includes(inputRef.current.value.toLowerCase()));
            } else {
                result = allParticipantsRef.current
            }

            let value = selectedFilter.value
            value = value.toUpperCase().replace(/S$/, '');

            if (value !== "ALL") {
                if (value === "MEMBER")
                    result = result.filter(participant => participant.role.includes(value) || participant.role.includes('ADMINISTRATOR'));
                else
                    result = result.filter(participant => participant.role.includes(value));
            }
            setDisplayedParticipants(result)
        }
    }, [inputRef.current?.value])

    useEffect(() => {
        if (participantsFilter === 'ALL' && allParticipantsRef.current) {
            let result = []
            result = allParticipantsRef.current

            if (inputRef.current.value) {
                result = result.filter(participant => participant.name?.toLowerCase().includes(inputRef.current.value.toLowerCase()));
            } else {
                result = result
            }

            setSelectedFilter({ value: "all", text: "All" })

            setDisplayedParticipants(result);
        }
    }, [participantsFilter])

    useEffect(() => {
        if (allParticipantsRef.current) {
            let value = selectedFilter.value
            value = value.toUpperCase().replace(/S$/, '');

            let result = []
            if (value !== "ALL") {
                if (value === "MEMBER")
                    result = allParticipantsRef.current.filter(participant => participant.role.includes(value) || participant.role.includes('ADMINISTRATOR'));
                else
                    result = allParticipantsRef.current.filter(participant => participant.role.includes(value));

            } else {
                result = allParticipantsRef.current
            }

            if (inputRef.current.value) {
                result = result.filter(participant => participant.name?.toLowerCase().includes(inputRef.current.value.toLowerCase()));
            } else {
                result = result
            }

            setDisplayedParticipants(result);
            setParticipantsFilter(value.toUpperCase().replace(/S$/, ''));
        }
    }, [selectedFilter])

    useEffect(() => {
        if(verifyFilters){
            let value = selectedFilter.value
            value = value.toUpperCase().replace(/S$/, '');

            let result = []
            if (value !== "ALL") {
                if (value === "MEMBER")
                    result = allParticipantsRef.current.filter(participant => participant.role.includes(value) || participant.role.includes('ADMINISTRATOR'));
                else
                    result = allParticipantsRef.current.filter(participant => participant.role.includes(value));

            } else {
                result = allParticipantsRef.current
            }

            if (inputRef.current?.value) {
                result = result.filter(participant => participant.name?.toLowerCase().includes(inputRef.current.value.toLowerCase()));
            } else {
                result = result
            }

            setDisplayedParticipants(result);
            setParticipantsFilter(value.toUpperCase().replace(/S$/, ''));
            setVerifyFilters(false)
        }
    },[verifyFilters])


    useEffect(() => {
        if ((!currentRoomAdmin || currentRoomAdmin?._id === currentUser?._id || currentRoomAdmin._id === currentParticipant?._id) || isRemote) {
            setVerifyShowList(true)
        } else {
            setVerifyShowList(false)
        }
    }, [displayedRoom, isRemote, currentRoomAdmin])

    function onTextChanged() {
        setDisplayedParticipants([])
    }

    const styleRefactoring = () => {
        currentTargetRef.current.style.transform = `translate(${0}px, ${0}px)`;
        currentTargetRef.current.style.position = 'relative';
        currentTargetRef.current.style.backgroundColor = "#2D2748"
        currentTargetRef.current.style.left = "0px";
        currentTargetRef.current.style.top = "0px";
        currentTargetRef.current.style.zIndex = 0
        currentTargetRef.current.style = currentTargetRef.current.priorStyle
    }

    const addParticipantToRoom = (desk) => {

        const availableDesk = desk

        // cautam daca unul dintre participanti este online
        let switchParticipant = attachedParticipants.find(
            (attached) => attached.desk?._id === availableDesk._id || attached.desk === availableDesk._id
        );

        if (switchParticipant) {
            switchParticipant.isOnline = switchParticipant?.desk._id === deskData?._id && currentConference?.status === "Active" ? true : false;

            const videos = participantsStreams.find((stream) => stream.participant._id === switchParticipant?.participant._id)

            if (videos) {
                switchParticipant.isOnline = true
            }

            if (switchParticipant.isOnline || switchParticipant.participant._id === currentConference?.moderatedBy) {
                setAlertMessage({ type: "ERROR", message: "The participant on the desk is in the conference." });

                styleRefactoring()

                return;
            }

            if ((uniqueModerators.some(moderator => moderator._id === switchParticipant?.participant._id))) {
                setAlertMessage({ type: "ERROR", message: "You can't remove a participant that is a moderator of the conference." })
                
                styleRefactoring()

                return;
            }

        }

        if (selectedParticipant.role === 'GUEST') {
            setAlertMessage({
                type: "ERROR",
                message: "The participant to add is a guest, and guests can only be added as remote participants."
            });

            styleRefactoring()

            return;
        }

        socketRef.current.emit("CONFERENCE_ADD_PARTICIPANT_TO_DESK", {
            conferenceId: currentConferenceRef.current._id,
            participantId: selectedParticipant._id,
            deskId: availableDesk._id,
            roomId: displayedRoom._id
        }, callback => {

            if (!callback.error) {
                socketRef.current.emit("DESK_PARTICIPANT_CHANGED", availableDesk._id);

                setAttachedParticipants(callback.response.attachedParticipants)

                let updatedParticipants = allParticipantsRef.current.filter((participant) => participant._id !== selectedParticipant._id)

                if (callback.response.removedParticipant)
                    updatedParticipants.push(callback.response.removedParticipant)


                allParticipantsRef.current = updatedParticipants;

                if (participantsFilter === "ALL") {

                    setDisplayedParticipants(updatedParticipants);
                }
                setParticipantsFilter('ALL')

                if (socketRef.current && currentUser) {
                    getUpcomingConferences(socketRef, currentUser._id, setNotificationUpcomingConferences)
                }
            }

        })
    }

    const addRemoteParticipant = () => {
        if (selectedParticipant.role === 'VISITOR') {
            setAlertMessage({
                type: "ERROR",
                message: "The participant to add is a visitor and visitors can only be added to conference rooms."
            });

            styleRefactoring()

            return;
        }

        socketRef.current.emit("CONFERENCE_ADD_REMOTE_PARTICIPANT", {
            conferenceId: currentConferenceRef.current._id,
            participantId: selectedParticipant._id,
        }, callback => {
            if (!callback.error) {
                setAttachedParticipants(callback.response)
                setDisplayedParticipants((prevParticipants) =>
                    prevParticipants.filter((participant) => participant._id !== selectedParticipant._id)
                );

                allParticipantsRef.current = allParticipantsRef.current.filter((participant) => participant._id !== selectedParticipant._id)
                if (socketRef.current && currentUser) {
                    getUpcomingConferences(socketRef, currentUser._id, setNotificationUpcomingConferences)
                }
                setSelectedInvites(invite => [...invite, selectedParticipant._id])
            }
        })

    }

    useEffect(() => {
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
            window.addEventListener("touchmove", handleMouseMove);
            window.addEventListener("touchend", handleMouseUp);
        }

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
            window.removeEventListener("touchmove", handleMouseMove);
            window.removeEventListener("touchend", handleMouseUp);
        };
    }, [isDragging]);

    const handleMouseDown = (e) => {
        e.stopPropagation()

        if (activeTouchIdRef.current !== null) {
            return;
        }

        if (currentTargetRef.current !== e.currentTarget) {
            currentTargetRef.current = e.currentTarget.parentNode
        }

        setIsDragging(true);

        if (e.touches) {

            const touch = Array.from(e.touches).find(t =>
                e.currentTarget.contains(document.elementFromPoint(t.clientX, t.clientY))
            );

            if (touch) {
                activeTouchIdRef.current = touch.identifier;

                currentTargetRef.current.startX = touch.clientX;
                currentTargetRef.current.startY = touch.clientY;

                currentTargetRef.current.lastX = touch.clientX;
                currentTargetRef.current.lastY = touch.clientY;

            }

        } else {

            activeTouchIdRef.current = null;

            currentTargetRef.current.startX = e.clientX;
            currentTargetRef.current.startY = e.clientY;

            currentTargetRef.current.lastX = e.clientX;
            currentTargetRef.current.lastY = e.clientY;
        }

        currentTargetRef.current.priorStyle = currentTargetRef.current.style

        currentTargetRef.current.style.zIndex = GetMaxZIndex() + 1
        currentTargetRef.current.style.backgroundColor = "#1f1b31"

        let boundingBox = currentTargetRef.current.getBoundingClientRect();
        currentTargetRef.current.style.position = 'fixed';


        currentTargetRef.current.style.left = String(boundingBox.x / oxDivider) + "px";
        currentTargetRef.current.style.top = String(boundingBox.y / oyDivider) + "px";

        Object.assign(currentTargetRef.current.style, {
            display: "flex",
            flexDirection: "column",
            width: "480px",
            height: "387px",
            borderRadius: "26px",
            background: "rgba(35, 26, 62, 0.3)",
            opacity: "1",
            backdropFilter: "blur(31px)",
            zIndex: GetMaxZIndex() + 1,
        });


    };

    const handleMouseMove = (e) => {
        e.stopPropagation()

        if (!isDragging) return;

        let newX = 0
        let newY = 0

        if (e.touches) {
            const touch = Array.from(e.touches).find(t => t.identifier === activeTouchIdRef.current)

            newX = (touch.clientX - currentTargetRef.current.startX) / oxDivider;
            newY = (touch.clientY - currentTargetRef.current.startY) / oyDivider;

            currentTargetRef.current.lastX = touch.clientX;
            currentTargetRef.current.lastY = touch.clientY;
        } else {
            newX = (e.clientX - currentTargetRef.current.startX) / oxDivider;
            newY = (e.clientY - currentTargetRef.current.startY) / oyDivider;

            currentTargetRef.current.lastX = e.clientX;
            currentTargetRef.current.lastY = e.clientY;
        }

        currentTargetRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
    };

    const handleMouseUp = (e) => {

        if (e.changedTouches) {
            const touch = Array.from(e.changedTouches).find(t => t.identifier === activeTouchIdRef.current);

            if (!touch) {
                return;
            }
        }

        setIsDragging(false);
        activeTouchIdRef.current = null

        let mouseX = currentTargetRef.current.lastX;
        let mouseY = currentTargetRef.current.lastY;


        const targetRect = tablePosition;

        if (isOverlapping(mouseX, mouseY, targetRect)) {

            if (isRemote) {
                addRemoteParticipant()
                return;
            }

            let tableWidth = tablePosition.width / oxDivider
            let tableHeight = tablePosition.height / oyDivider

            let insidePosX = (mouseX - targetRect.x) / oxDivider
            let insidePosY = (mouseY - targetRect.y) / oyDivider

            let desk = {}
            let deskWidth = 0

            if (displayedRoom.edges[0] !== 0) {
                deskWidth = (tableWidth - 2 * deskHeight) / displayedRoom.edges[0]
            } else {
                deskWidth = (tableWidth - 2 * deskHeight) / displayedRoom.edges[2]
            }

            let center = false

            if (insidePosY <= deskHeight) {

                let posNumber = Math.floor((insidePosX - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_north[posNumber]

            } else if (insidePosY >= tableHeight - deskHeight) {

                let posNumber = Math.floor((insidePosX - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_south[posNumber]

            } else if (insidePosX <= deskHeight) {

                let posNumber = Math.floor((insidePosY - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_west[posNumber]

            } else if (insidePosX >= tableWidth - deskHeight) {

                let posNumber = Math.floor((insidePosY - deskHeight) / deskWidth)
                if (posNumber <= displayedRoom.desks_north.length) desk = displayedRoom.desks_east[posNumber]

            } else {
                center = true
            }

            if (desk && desk._id) {

                if (verifyRoomAdmin) {
                    setAlertMessage({ type: "ERROR", message: "You can't add people to the conference before choosing the room admin." });
                } else {
                    addParticipantToRoom(desk)
                    return;
                }

            } else if (center && verifyRoomAdmin) {
                addRoomAdmin()
                currentTargetRef.current.style.opacity = 0
                return;
            }
        }
        styleRefactoring()
    };

    const isOverlapping = (mouseX, mouseY, rect) => {

        return (
            mouseX >= rect.left &&
            mouseX <= rect.right &&
            mouseY >= rect.top &&
            mouseY <= rect.bottom
        );

    };

    const handleDelete = (ev, participant) => {

        const rect = ev.target.getBoundingClientRect();

        setDeleteClicked({
            shown: true,
            funct: () => removeParticipantFromProject(participant),
            name: "Participant",
            x: rect.x + 130,
            y: rect.y,
            onClose: () => setDeleteClicked(),
        });
    };

    const removeParticipantFromProject = (participant) => {

        socketRef.current.emit("DELETE_PARTICIPANT_FROM_PROJECT",
            { projectId: currentConferenceRef.current.project, participantId: participant._id }, (result) => {
                if (result.error) {
                    setAlertMessage({ type: "ERROR", message: result.message });
                } else {
                    setDeleteClicked(false);
                    setDisplayedParticipants(dp => dp.filter(part => part._id !== participant._id));
                }
            }
        );
    }

    const addRoomAdmin = () => {
        setAlertMessage({ type: "WARNING", message: "Room admin selected. Please wait for confirmation." });
        setVerifyShowList(false)

        socketRef.current.emit("CONFERENCE_ADD_ROOM_ADMIN", {
            roomId: displayedRoom._id,
            userId: selectedParticipant._id,
            conferenceId: currentConferenceRef.current._id
        }, callback => {
            if (!callback.error) {
                if (editConference) {
                    setEditConference(prev => ({
                        ...prev,
                        roomAdmins: callback.response.roomAdmins
                    }))
                }
                if (conferenceDetailsForParticipants) {

                    setConferenceDetailsForParticipants(prev => ({
                        ...prev,
                        roomAdmins: callback.response.roomAdmins
                    }))
                }
                if (currentConference) {

                    setCurrentConference(prev => ({
                        ...prev,
                        roomAdmins: callback.response.roomAdmins
                    }))

                }

                setCurrentRoomAdmin(callback.response.adminData)

                setAlertMessage({ type: "SUCCESS", message: "Room admin confirmed selection." });

            } else {
                console.log(callback.error)
                setAlertMessage({ type: "ERROR", message: callback.error });
            }
            currentTargetRef.current.style.opacity = 1
            styleRefactoring()
        })
    }

    useEffect(() => {
        if (!Array.isArray(displayedParticipants)) {
            console.error("displayedParticipants is not an array:", displayedParticipants);
            return;
        }
        if (!nameRefs.current) {
            console.error("nameRefs.current is not defined");
            return;
        }


        const updatedStates = displayedParticipants.map((index) => {
            const container = nameRefs.current?.[index];
            if (!container) {
                return false;
            }
            return container.scrollWidth > container.offsetWidth;
        });

        setScrollableStates([...updatedStates]); // Ensure a state change
    }, [displayedParticipants, nameRefs]);


    return (
        <div className={styles.component}>

            <div className={styles.participantsFilter} ref={participantsFilterSearchRef}>
                <CustomDropdownComponent width={733} openBodyMaxHeight={500} options={filteredOptions} currentChoice={selectedFilter} setCurrentChoice={setSelectedFilter}
                    style={{ marginLeft: "0px" }} />

                <New_InputTextComponent ref={inputRef} marginTop="40px" fontSize="30" width={733} height="80px" keyboardRef={keyboardRef} value="" styleType='SEARCHPOPUP'
                    placeHolder={language.add_participants.Search} iconPosition="left" icon={byPrefixAndName.fal["magnifying-glass"]} withDelete={true} onChange={() => onTextChanged()} />

            </div>
            <div className={styles.participantsList}>
                <div className={styles.participantsListContent} onScroll={(e) => {
                    if (isDragging) {
                        e.preventDefault()
                    }
                }}>
                    {verifyShowList &&
                        displayedParticipants?.map((participant, index) => <div key={participant._id} className={styles.participantCard}>
                            <div onMouseDown={(e) => {
                                handleMouseDown(e)
                                setSelectedParticipant(participant)
                            }}
                                onTouchStart={(e) => {
                                    handleMouseDown(e)
                                    setSelectedParticipant(participant)
                                }}>
                                <InitialsCircleComponent name={participant.name} style={{ marginLeft: 25, height: 121, width: 121, border: "6px solid #0D0032", marginBottom: 10, zIndex: 0 }} />
                            </div>

                            <div className={styles.participantDetails}>
                                <div style={{ letterSpacing: "2.2px" }}>{participant.role}</div>
                                <div
                                    className={`${styles.participantName} ${scrollableStates[index] ? styles.scrollActive : ""}`}
                                    ref={(el) => (nameRefs.current[index] = el)}
                                >
                                    <span>{participant.name}</span>
                                </div>
                                {participant.function?.name}
                                {participant.function ? ` | ${participant.department?.name}` : null}
                            </div>
                            <div className={styles.iconRemoveZone} onClick={(e) => { handleDelete(e, participant) }}>
                                <FontAwesomeIcon className={styles.iconRemove} icon={byPrefixAndName.fal['trash']} />
                            </div>

                        </div>)}

                </div>
                <div className={styles.participantListShadow_bottom} style={{ pointerEvents: 'none' }} />
                <div className={styles.participantListShadow_top} style={{ pointerEvents: 'none' }} />



            </div>

            <div className={styles.footer}>
                {!isRemote && verifyShowList && <DarkButtonComponent style={{ position: "relative", width: 350 }} onClick={() => setAddVisitor(true)}>
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['plus']} /> Add Visitor
                </DarkButtonComponent>}

                {isRemote && <DarkButtonComponent style={{ position: "relative", width: 350 }} onClick={() => setAddGuest(true)}>
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['plus']} /> Add Guest
                </DarkButtonComponent>}
            </div>

            {deleteClicked?.shown === true && <DeleteNotificationComponent deleteClicked={deleteClicked} setDeleteClicked={setDeleteClicked} />}

        </div>

    );

}

export default NotAttachedParticipantsComponent;